import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ChangeDetectorRef, Component, ElementRef, Inject, NgZone, OnInit, Renderer2 } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { JobApplication } from 'src/@core/interfaces/job/job-application.model';
import { Search } from 'src/@core/interfaces/search';
import { AppService, CURRENT_USER } from 'src/@core/services/app.service';
import { EmploymentHistoryService } from 'src/@core/services/employment/employment-history.service';
import { JobSeekerService } from 'src/@core/services/job-seeker/job-seeker.service';
import { JobApplicationService } from 'src/@core/services/job/job-application.service';
import { JobService } from 'src/@core/services/job/job.service';
import { NotificationService } from 'src/@core/services/notification.service';
import { API_EMPLOYMENT_HISTORY_COORDINATES } from 'src/@core/services/util/api.endpoints';
import { entityTypes, roles } from 'src/app/shared/helpers/roles-permissions';

@Component({
  selector: 'hour4u-admin-map-view-with-project',
  templateUrl: './map-view-with-project.component.html',
  styleUrls: ['./map-view-with-project.component.scss']
})
export class MapViewWithProjectComponent implements OnInit {
  isLoading: boolean = false;
  profile = this.appService.getCurrentAccount();
  roles = roles;
  entityTypes = entityTypes;
  selectedAgency: any = null;
  selectedCreatedOn: any = null;
  selectedCreatedBy: any = null;
  selectedExpiredBy: any = null;
  agenciesList: any[] = [];
  createdByList: any[] = [];
  selectedOptions: any = ["Active"];
  selectedCityOptions: any;
  selectedAgencyOptions: any = [];

  multiselectOptions = [
    // { value: 'Approved', label: 'Approved' },
    { value: 'Pending', label: 'Pending' },
    { value: 'Completed', label: 'Completed' },
    { value: 'Active', label: 'Active' },
    { value: 'Rejected', label: 'Rejected' }
  ];

  cityMultiselectOptions = [
    { value: 'Delhi', label: 'Delhi' },
    { value: 'Gurugram', label: 'Gurugram' },
    { value: 'Mumbai', label: 'Mumbai' },
    { value: 'Bangalore', label: 'Bangalore' },
    { value: 'Hyderabad', label: 'Hyderabad' },
    { value: 'Chennai', label: 'Chennai' },
    { value: 'Kolkata', label: 'Kolkata' },
    { value: 'Pune', label: 'Pune' },
    { value: 'Dehradun', label: 'Dehradun' },
  ];
  agencyMultiselectOptions = [];
  filteredAgencyOptions: any[] = [];
  diameter = 40;
  color: string;
  mode = 'indeterminate';
  defaultLatitude = 28.457523;
  defaultLongitude = 77.026344;
  zoom = 15; // Example zoom level
  geoFencingRadius = 1000; // Example radius in meters

  infoWindowLatitude: number;
  infoWindowLongitude: number;
  infoWindowOpen: boolean = false;
  selectedWorkOrder: any = null;
  showWorkorderDetailsCards: boolean = false;
  projectsList: any[] = [];
  jobApplications: JobApplication[];
  jobApplicationPage: JobApplication[];
  employment: any;
  totalTasks: number = 0;
  workImages: any[] = [];
  showMapDetailsView: boolean = false;
  selectedJobSeekers: any[] = [];
  selectedJobSeeker: any = "";
  selectedProjectId: any = null;
  forAll: boolean = true;
  selectedJobSeekerDetails: any = null;
  selectedJobSeekerId: string = null;
  resultsLength: number = 0;
  selectedStatus: any = ['Active'];
  selectedCity: string = '';
  selectedProject: any;
  assignedEntities: any[] = [];
  selectedAssignedEntity: any = null;
  showBackBtn: boolean = false;
  allTaskMarkers: { latitude: number; longitude: number }[] = [];
  isLoadingMarkers: boolean = false;
  fullScreenBtnText: string = 'Full Screen';
  isFullScreen: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<MapViewWithProjectComponent>,
    private appService: AppService,
    private service: JobService,
    private cdr: ChangeDetectorRef,
    private jobApplicationService: JobApplicationService,
    private jobSeekerService: JobSeekerService,
    public employmentHistoryService: EmploymentHistoryService,
    private notify: NotificationService,
    private zone: NgZone,
    private http: HttpClient,
    private el: ElementRef, private renderer: Renderer2
  ) { }

  ngOnInit() {
    console.log(this.data, this.showMapDetailsView)
    console.log(this.selectedOptions)
    this.geoFencingRadius = this.data.selectedProject.geoFencingRadius;
    this.selectedProjectId = this.data.selectedProject.id;
    this.setChampMarkers();
    this.updateZoom();
    this.getAllAgencies();
    this.fetchAllProjects();
  }

  onFilterChange(): void {
    this.fetchWorkOrdersData();
  }

  fetchWorkOrdersData() {
    this.isLoading = true;
    // let startDate = "";
    // let endDate = "";
    // if (this.selected && this.selected.startDate && this.selected.endDate) {
    //   startDate = moment(this.selected.startDate).format("YYYY-MM-DD");
    //   endDate = this.selected.endDate.toISOString().split("T")[0];
    // }
    if (this.profile.entity.entityType === 'AGENCY') {
      this.selectedAgency = [];
      this.selectedAgency.push(this.profile.entity.id);
    }
    console.log(this.selectedOptions)
    let obj = {
      "jobId": this.selectedProjectId,
      "status": this.selectedOptions,
      "city": this.selectedCityOptions,
      "agency": this.selectedAgency,
      // "startDate": startDate,
      // "endDate": endDate,
    }
    this.service.fetchWorkorderByJobId(obj)
      .subscribe(
        (response) => {
          this.data.workorders = response;
          this.data.workorders.forEach((workOrder) => {
            if (workOrder.activationProof === null) {
              workOrder.activationProof = { status: 'PENDING' };
            }
          });
          this.isLoading = false;
          this.setChampMarkers();
          this.zone.run(() => {
            this.showBackBtn = false;
            this.cdr.detectChanges();
          }, 0);
        },
        (error) => {
          this.isLoading = false;
          console.error('Failed to fetch dashboard data:', error);
        }
      );
  }

  setChampMarkers() {
    if (this.data && this.data.workorders && this.data.workorders.length) {
      this.defaultLatitude = this.getCircleLatitude(this.data.workorders[0]);
      this.defaultLongitude = this.getCircleLongitude(this.data.workorders[0]);
      this.data.workorders.forEach(element => {
        if (element.champDetails && element.champDetails.length) {
          element.champDetails.forEach(ele => {
            ele.icon = {
              url: ele.profile ? ele.profile : 'assets/img/avatars/male_avatar.svg',
              scaledSize: {
                width: 32,
                height: 32
              }
            }
          });
        }
      });
    }
  }

  getAllAgencies() {
    this.isLoading = true;
    const searchParams = [];
    const entityId = this.profile.entity.id;
    if (entityId) {
      searchParams.push(new Search('entityType', 'AGENCY'));
      this.service.searchAndSortAgencies(entityId, 0, 1000, 'createdOn', null, searchParams)
        .subscribe(data => {
          this.isLoading = false;
          this.agencyMultiselectOptions = data.content.map(agency => ({
            value: agency.id,
            label: agency.entityMeta.name
          }));
          this.filteredAgencyOptions = this.agencyMultiselectOptions;
        }, error => {
        });
    } else {
      this.isLoading = false;
      console.warn('Entity ID is not available. Unable to fetch agencies.');
    }
  }

  fetchAllProjects() {
    let searchParams = [];
    if (this.profile.entity.entityType === 'ENTERPRISE') {
      searchParams.push(new Search('employerId', JSON.parse(localStorage.getItem(CURRENT_USER)).entity.id))
    } else {
      searchParams.push(new Search('entityId', JSON.parse(localStorage.getItem(CURRENT_USER)).entity.id))
    }
    this.service!.searchAndSort(
      0,
      1000,
      'createdOn',
      'desc',
      searchParams
    ).subscribe((data: any) => {
      console.log(data)
      if (data.content && data.content.length) {
        data.content = data.content.sort((a, b) => {
          return a.title.localeCompare(b.title);
        });
      }
      this.projectsList = [];
      data.content.forEach(element => {
        if (element.attendanceAtVenueRequired || element.attendanceLocationTrackerRequired) {
          this.projectsList.push(element);
        }
      });
      this.selectedProject = this.projectsList.filter(data => data.id == this.selectedProjectId);
      if (this.selectedProject && this.selectedProject.length > 0) {
        this.assignedEntities = this.selectedProject[0].assignedEntities;
      }
      console.log(this.selectedProject)
      this.cdr.detectChanges();
    })
  }


  getCircleLatitude(workOrder) {
    return workOrder.venue.location.latitude;
  }

  getCircleLongitude(workOrder) {
    return workOrder.venue.location.longitude;
  }

  updateZoom() {
    if (this.geoFencingRadius >= 10000) {
      this.zoom = 10;
    } else if (this.geoFencingRadius >= 5000) {
      this.zoom = 11;
    } else if (this.geoFencingRadius >= 2500) {
      this.zoom = 12;
    } else if (this.geoFencingRadius >= 1000) {
      this.zoom = 11;
    } else if (this.geoFencingRadius >= 500) {
      this.zoom = 16;
    } else if (this.geoFencingRadius >= 200) {
      this.zoom = 17;
    } else if (this.geoFencingRadius >= 100) {
      this.zoom = 18;
    }
  }

  onMouseOver(infoWindow, gm) {
    if (gm.lastOpen != null) {
      gm.lastOpen.close();
    }
    gm.lastOpen = infoWindow;
    infoWindow.open();
  }

  onImageError(event: Event): void {
    const imgElement = event.target as HTMLImageElement;
    imgElement.src = '/assets/img/avatars/male_avatar.svg';
  }

  showInfoWindow(workorder: any, infoWindow: any, map: any) {
    this.infoWindowLatitude = workorder.venue.location.latitude;
    this.infoWindowLongitude = workorder.venue.location.longitude;
    this.infoWindowOpen = true;
    this.selectedWorkOrder = workorder; // Store the selected workorder
    infoWindow.open(); // Open the info window
    this.cdr.detectChanges();
  }

  getEachFulfilment(element: any, billingItems: any[]): number {
    if (element && element.numberOfVariableFulfilment && element.numberOfVariableFulfilment) {
      return element.numberOfVariableFulfilment;
    } else {
      if (billingItems && billingItems.length > 0) {
        // Only calculate the quantity of the item at index 0 i.e selected JobType
        return billingItems[0].quantity || 0;
      }
    }
    return 0;
  }

  showHideWorkorderDetails() {
    this.showWorkorderDetailsCards = !this.showWorkorderDetailsCards;
    if (!this.showWorkorderDetailsCards) {
      (document.querySelector('.workorder-card-view-btn-wrap') as HTMLElement).style.width = '93%';
    }
    if (this.showWorkorderDetailsCards) {
      (document.querySelector('.workorder-card-view-btn-wrap') as HTMLElement).style.width = '66%';
    }
  }

  setShowHideBtnWidth() {
    if (!this.showWorkorderDetailsCards) {
      (document.querySelector('.workorder-card-view-btn-wrap') as HTMLElement).style.width = '93%';
    }
    if (this.showWorkorderDetailsCards) {
      (document.querySelector('.workorder-card-view-btn-wrap') as HTMLElement).style.width = '66%';
    }
  }

  changeProject() {
    let selectedProject: any = this.projectsList.filter(data => data.id == this.selectedProjectId);
    if (selectedProject && selectedProject.length) {
      this.geoFencingRadius = selectedProject[0].geoFencingRadius;
    } else {
      this.geoFencingRadius = this.data.selectedProject.geoFencingRadius;
    }
    this.fetchWorkOrdersData();
    this.updateZoom();
  }

  // STEP 2
  async loadJobApplications() {
    this.isLoading = true;
    this.jobApplications = [];
    // this.tableWorkImages = new MatTableDataSource();
    // this.notify.showMessage('Loading applicants .....', 2000);
    console.log(" this.employment===========", this.employment)
    const serachParams = [];
    // [new Search('employmentId', this.employment.id)];
    serachParams.push(new Search('status', 'COMPLETED'));
    serachParams.push(new Search('status', 'APPROVED'));
    serachParams.push(new Search('employmentId', this.employment.workOrder.id));
    this.showMapDetailsView = false;
    this.selectedJobSeekers = [];
    await this.jobApplicationService.searchAndSort(0, 5000, null, null, serachParams).toPromise()
      .then(data => {
        if (data.content.length > 0) {
          this.jobApplications = data.content;
          this.resultsLength = this.jobApplications.length;
          console.log("js", this.jobApplications);
          this.jobApplications.forEach((ja, index) => {
            // laod js
            this.jobSeekerService.getById(ja.jobSeekerId).toPromise()
              .then((js) => {
                ja.tempJobSeeker = js;
                this.selectedJobSeekers.push(js);
                // load history
                this.employmentHistoryService.searchAndSort(0, 1000, null, null, [new Search('employmentId', this.employment.workOrder.id), new Search('jobSeekerId', ja.jobSeekerId)]).toPromise()
                  .then(async (data) => {
                    ja.history = data.content[0];
                    this.jobApplicationPage = this.jobApplications.slice(0, 100);
                    this.workImages = [];
                    for (let i = 0; i < this.jobApplicationPage.length; i++) {
                      let ele = this.jobApplicationPage[i];
                      if (this.selectedJobSeeker && this.selectedJobSeeker.id) {
                        if (ele.jobSeekerId == this.selectedJobSeeker.id) {
                          this.selectedJobSeekerDetails = ele;
                          // this.selectedJobSeeker = ele;
                          if (this.selectedJobSeekerDetails.history && this.selectedJobSeekerDetails.history.imageProofs && this.selectedJobSeekerDetails.history.imageProofs.length) {
                            this.workImages = this.selectedJobSeekerDetails.history.imageProofs.filter(ip => ip.proofEnum == 'MIDDLE');
                            if (this.workImages && this.workImages.length) {
                              let isImageField = this.workImages[0].workProofs.filter((ip: any) => ip.fieldType === 'file')
                              console.log("$$$$$$$$$$$", isImageField)
                              let isFileFieldAvailable = false;
                              if (isImageField && !isImageField.length) {
                                isFileFieldAvailable = false;
                              } else {
                                isFileFieldAvailable = true;
                              }
                              this.workImages.forEach((el: any) => {
                                el.tempJobSeeker = ele;
                                el.tempJobSeekerName = ele.tempJobSeeker.name;
                                el.tempJobSeekerMobile = ele.tempJobSeeker.mobile;
                                el.tempJobSeekerId = ele.tempJobSeeker.entityId;
                                el.jobSeekerId = ele.tempJobSeeker.id;
                                el.isFileFieldAvailable = isFileFieldAvailable;
                                if (ja.history && ja.history.id)
                                  el.employmentHistoryId = ja.history.id;
                              })
                            }
                          }
                        }
                      } else {
                        if (ele.history) {
                          let prrof = JSON.parse(JSON.stringify(ele.history))
                          if (prrof.imageProofs) {
                            let workImages = prrof.imageProofs.filter(ip => ip.proofEnum == 'MIDDLE');
                            if (workImages.length) {
                              let isImageField = workImages[0].workProofs.filter((ip: any) => ip.fieldType === 'file')
                              console.log("$$$$$$$$$$$", isImageField)
                              let isFileFieldAvailable = false;
                              if (isImageField && !isImageField.length) {
                                isFileFieldAvailable = false;
                              } else {
                                isFileFieldAvailable = true;
                              }
                              workImages.forEach((el: any) => {
                                el.tempJobSeeker = ele;
                                el.tempJobSeekerName = ele.tempJobSeeker.name;
                                el.tempJobSeekerMobile = ele.tempJobSeeker.mobile;
                                el.tempJobSeekerId = ele.tempJobSeeker.entityId;
                                el.jobSeekerId = ele.tempJobSeeker.id;
                                el.isFileFieldAvailable = isFileFieldAvailable;
                                if (ja.history && ja.history.id)
                                  el.employmentHistoryId = ja.history.id;
                                this.workImages.push(el)
                              })
                            }
                          }
                        }
                      }
                    }
                    if (this.workImages && this.workImages.length) {
                      this.workImages.forEach(ele => {
                        if (ele && ele.dateTime && ele.dateTime.length) {
                          ele.datee = new Date(ele.dateTime[0] + "-" + ele.dateTime[1] + "-" + ele.dateTime[2])
                          ele.time = [ele.dateTime[3], ele.dateTime[4]];
                        }
                        ele.workProofs.forEach(element => {
                          if (element.fieldName == "") {
                            element.fieldName = "-"
                          }
                          if (element.fieldLabel == "") {
                            element.fieldLabel = "-"
                          }
                          ele[element['fieldName']] = element['fieldValue'];
                        });
                      })
                    }
                    this.workImages = this.workImages.reverse();
                    // this.tableWorkImages = new MatTableDataSource(this.workImages);
                    console.log(this.workImages)
                    console.log("jobApplications=", this.jobApplications)
                    // await this.cdRef.detectChanges();
                    // await this.columnDefined();
                    // await this.loadList();
                    if (index == this.resultsLength - 1) {
                      this.showMapDetailsView = true;
                      this.isLoading = false;
                    }

                    this.zone.run(() => {
                      this.showMapDetailsView = true;
                      this.cdr.detectChanges();
                    }, 0);
                  });
              });

          });
        } else {
          this.isLoading = false;
          this.notify.showMessage("No application found with this workorder!", 3000);
        }
      }).catch(err => {
        this.isLoading = false;
      })
  }

  openDetailsView(workorder, event: MouseEvent) {
    event.stopPropagation();
    this.employment = {};
    this.employment.project = this.data.selectedProject;
    this.employment.workOrder = workorder;
    this.selectedJobSeeker = null;
    this.forAll = true;
    this.loadJobApplications();
    this.cdr.detectChanges();
  }

  viewDirectChampDetailsView(jobSeeker: any, workorder: any) {
    console.log(jobSeeker, workorder)
    this.selectedJobSeeker = jobSeeker;
    this.showMapDetailsView = false;
    this.selectedJobSeekerId = jobSeeker.id;
    this.employment = {};
    this.employment.project = this.data.selectedProject;
    this.employment.workOrder = this.selectedWorkOrder ? this.selectedWorkOrder : workorder;
    setTimeout(() => {
      if (this.selectedJobSeekerId) {
        this.forAll = false;
      } else {
        this.forAll = true;
      }
      this.showMapDetailsView = true;
      this.loadJobApplications();
      this.cdr.detectChanges();
    }, 0);
  }

  selectedJobSeekerSet(jobSeeker?: any) {
    this.selectedJobSeeker = jobSeeker;
    console.log(this.selectedJobSeeker)
  }

  changeJobSeeker() {
    this.showMapDetailsView = false;
    setTimeout(() => {
      if (this.selectedJobSeekerId) {
        this.forAll = false;
      } else {
        this.forAll = true;
      }
      this.showMapDetailsView = true;
      // this.loadJobApplications();
      this.cdr.detectChanges();
    }, 0);
  }

  closeDialog() {
    this.dialogRef.close(true);
  }

  clearCitySelection(eventData: Event): void {
    this.selectedCityOptions = null;
    this.selectedCity = null;
    this.fetchWorkOrdersData();
    eventData.stopPropagation();
  }

  clearAgencySelection(eventData: Event): void {
    this.selectedAgency = null;
    this.fetchWorkOrdersData();
    eventData.stopPropagation();
  }
  clearStatusSelection(eventData: Event) {
    this.selectedOptions = null;
    this.selectedStatus = null;
    this.fetchWorkOrdersData();
    eventData.stopPropagation();
  }

  searchAgencyByInput(event) {
    console.log(this.agencyMultiselectOptions)
    const searchText = event.target.value.toLowerCase();
    this.filteredAgencyOptions = this.agencyMultiselectOptions.filter(data => {
      // Check if data.label is not null and is a string
      if (data.label && typeof data.label === 'string') {
        return data.label.toLowerCase().indexOf(searchText) !== -1;
      }
      return false; // Exclude items with null label or non-string label
    });
  }

  moveToSelectedWorkOrder(workorder) {
    console.log(workorder)
    this.defaultLatitude = this.getCircleLatitude(workorder);
    this.defaultLongitude = this.getCircleLongitude(workorder);
    this.selectedWorkOrder = workorder;
    this.data.workorders = [];
    this.data.workorders.push(this.selectedWorkOrder);
    this.showBackBtn = true;
  }

  showAllTaskMarkers(jobId: string): void {
    this.isLoadingMarkers = true;
    const url = `${API_EMPLOYMENT_HISTORY_COORDINATES}/${jobId}`;

    this.http.get<{ latitude: number, longitude: number }[]>(url).subscribe(
      (response) => {
        this.allTaskMarkers = response.filter(coord => coord.latitude !== null && coord.longitude !== null);
        console.log(this.allTaskMarkers);
        this.isLoadingMarkers = false;
      },
      (error) => {
        console.error('Error fetching coordinates:', error);
        this.isLoadingMarkers = false;
      }
    );
  }

  showFullScreen() {
    if (this.isFullScreen) {
      // Exit Full Screen
      this.fullScreenBtnText = 'Enter Full Screen';
      console.log('Exiting full screen mode.');

      // Remove the global class to restore original styles
      this.renderer.removeClass(document.body, 'map-view-zero-margin');
    } else {
      // Enter Full Screen
      this.fullScreenBtnText = 'Exit Full Screen';
      console.log('Entering full screen mode.');

      // Add the global class to set margin to 0
      this.renderer.addClass(document.body, 'map-view-zero-margin');
    }

    // Toggle the full-screen state
    this.isFullScreen = !this.isFullScreen;
  }

}
